import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from '../Footer';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onPageChange: (page: string) => void;
  isFocusMode?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, currentPage, onPageChange, isFocusMode: focusModeOverride }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  // 데스크톱에서는 사이드바 접힌 상태, 모바일에서는 닫힌 상태
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarOpen(true); // 데스크톱에서는 열려있지만
        setIsSidebarCollapsed(true); // 기본적으로 접힌 상태
      } else {
        setIsSidebarOpen(false); // 모바일에서는 기본적으로 닫힌 상태
        setIsSidebarCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuToggle = () => {
    if (window.innerWidth > 768) {
      // 데스크톱에서는 접기/펼치기 또는 열기/닫기
      if (isSidebarOpen) {
        setIsSidebarCollapsed(!isSidebarCollapsed);
      } else {
        setIsSidebarOpen(true);
        setIsSidebarCollapsed(false);
      }
    } else {
      // 모바일에서는 열기/닫기
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  const isDesktop = window.innerWidth > 768;
  const isFocusMode = focusModeOverride ?? currentPage === 'exam';

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className={`layout ${isFocusMode ? 'layout--focus' : ''}`}>
      {!isFocusMode && (
        <Header
          onMenuToggle={handleMenuToggle}
          isSidebarOpen={isSidebarOpen}
          isSidebarCollapsed={isSidebarCollapsed}
          isDesktop={isDesktop}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      )}
      
      {!isFocusMode && (
        <Sidebar
          isOpen={isSidebarOpen}
          isCollapsed={isSidebarCollapsed}
          currentPage={currentPage}
          onPageChange={onPageChange}
          onClose={handleSidebarClose}
        />
      )}
      
      <main className={`layout__main ${!isFocusMode && isSidebarOpen ? (isSidebarCollapsed ? 'layout__main--sidebar-collapsed' : 'layout__main--sidebar-open') : ''}`}>
        <div className="layout__content">
          {children}
        </div>
      </main>
      
      {!isFocusMode && <Footer />}
    </div>
  );
};

export default Layout;
